import React from "react";
import Lottie from "react-lottie";
import { Link } from "react-router-dom";
import successAnimation from "assets/lottie/success.json";

interface SuccessMessageProps {
  title?: string;
  description?: string;
  btnText?: string;
  btnLink?: string;
  showDescription?: boolean;
  showTitle?: boolean;
  iconHeight?: number;
  animation?: any;
  iconWidth?: number;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  title,
  description,
  btnText,
  btnLink,
  showDescription = false,
  showTitle = true,
  iconHeight = 230,
  iconWidth = 300,
  animation = successAnimation,
}) => {
  const lottieOptions = {
    loop: false,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="text-center result-area">
      <Lottie
        options={lottieOptions}
        height={iconHeight}
        width={iconWidth}
        isClickToPauseDisabled={true}
      />
      {showTitle && <h2> {title}</h2>}

      {showDescription && description && <p>{description}</p>}

      {btnText && btnLink && (
        <Link to={btnLink} className="btn btn-black ">
          {btnText}
        </Link>
      )}
    </div>
  );
};

export default SuccessMessage;
